import '../Admin/admin-shared.css'

import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { useNavigate } from 'react-router-dom'

import { Spinner } from '../../Components'
import { useCQuery } from '../../Services'
import { cap } from '../../State'
import { translations } from '../../translations'
import { columnProps } from './Functions'

const language = cap.language.state || 'IT'
const t = translations[language]

export function PromptsTable() {
  const { data: prompts, isSuccess } = useCQuery(['prompts'])
  const navigate = useNavigate()

  const BtnActions = ({ id }) => (
    <button type="button" className="nbtn nbtn--sm" onClick={() => navigate(`/prompts/${id}`)}>
      <i className="pi pi-pencil" style={{ fontSize: 13 }} />
      {t.modifica}
    </button>
  )

  if (!isSuccess) return <Spinner />
  return (
    <div className="ncard admin-table-card" style={{ padding: 0 }}>
      <div className="ncard__head">
        <div className="ncard__ico">
          <i className="pi pi-file-edit" style={{ fontSize: 16 }} />
        </div>
        <div>
          <h3 className="ncard__title">{t.prompt}</h3>
        </div>
      </div>
      <DataTable
        style={{ width: '100%' }}
        value={prompts}
        emptyMessage={t.nessunPromptInserito}
        responsiveLayout="scroll"
        paginator
        rows={10}
        className="TableSignatures"
        filterDisplay="row"
        sortField="createdAt"
        sortOrder={-1}
      >
        <Column
          field="jsonField"
          {...columnProps(t.campo)}
          body={({ jsonField }) => <span className="prompt-json-field">{jsonField}</span>}
        />
        <Column
          field="basePrompt"
          {...columnProps(t.spiegazione)}
          body={({ basePrompt }) => (
            <span style={{ color: 'var(--ink-700)', fontSize: 13 }}>{basePrompt}</span>
          )}
        />
        <Column
          headerStyle={{ visibility: 'hidden' }}
          style={{ border: 'none', width: 140, textAlign: 'right' }}
          body={(props) => <BtnActions {...props} />}
        />
      </DataTable>
    </div>
  )
}
